"use client";

import { useEffect } from "react";

const META_PIXEL_ID = "1966093087124184";

declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}

// Bootstraps the Meta Pixel `fbq` queue and downloads fbevents.js. The
// `<script>` tag is `async` so it never blocks parsing or paint; the
// `window.fbq` queue stub is set up synchronously inside this effect so any
// caller that fires `fbq("track", ...)` (e.g. the `Subscribe` event on
// `/success`) hits a real queue instead of `undefined`.
function initMetaPixel() {
  if (typeof window === "undefined") return;
  if (window.fbq) return;

  const f = window as any;
  const b = document;
  const e = "script";
  const v = "https://connect.facebook.net/en_US/fbevents.js";

  let n: any;
  n = f.fbq = function () {
    n.callMethod
      ? n.callMethod.apply(n, arguments)
      : n.queue.push(arguments);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = "2.0";
  n.queue = [];

  const t = b.createElement(e) as HTMLScriptElement;
  t.async = true;
  t.src = v;
  const s = b.getElementsByTagName(e)[0];
  if (s?.parentNode) {
    s.parentNode.insertBefore(t, s);
  } else {
    // Fallback: HTML may not have a <script> tag yet (e.g. body still
    // streaming). Append directly to <head> so we don't throw on
    // `s.parentNode` when `s` is undefined.
    document.head.appendChild(t);
  }

  f.fbq("init", META_PIXEL_ID);
  f.fbq("track", "PageView");
}

// Loads on mount, deferred to browser idle time when supported. This pairs
// with the `async` `<script>` tag inside `initMetaPixel()` to keep the SDK
// off the LCP critical path while still guaranteeing it loads shortly after
// the page settles — never gated on user interaction, so server-redirect
// pages like `/success` (no clicks before tracking fires) still get the
// queue stubs in time.
function scheduleInit() {
  if (typeof window === "undefined") return;
  const ric = (window as Window & {
    requestIdleCallback?: (cb: () => void) => void;
  }).requestIdleCallback;
  if (ric) {
    ric(initMetaPixel);
  } else {
    setTimeout(initMetaPixel, 0);
  }
}

export default function MetaPixel() {
  useEffect(() => {
    scheduleInit();
  }, []);

  return null;
}
